import request from "../utils/request";

/** 自動化規則清單 */
export function GET_AutomationList(token, payload) {
  return request.get("/Automation/List", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** 啟用 / 停用規則 */
export function POST_AutomationToggle(token, payload) {
  return request.post("/Automation/Toggle", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

/** 新增規則 */
export function POST_Automation(token, payload) {
  return request.post("/Automation", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

/** 編輯規則 */
export function PUT_Automation(token, payload) {
  return request.put("/Automation", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

/** 刪除規則 */
export function DELETE_Automation(token, payload) {
  return request.delete("/Automation", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
